import React, { useState } from 'react';
import { View, StyleSheet, FlatList, TouchableOpacity, Image } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight as arrowIcon } from '@fortawesome/free-solid-svg-icons';
import { useRoute } from '@react-navigation/native';
import { themeConfig } from '../../styles/themeConfig';
import voucherJson from '../../assets/data/voucher.json';
import { BText, Drawer } from '../../components';
import voucherThumbnail from '../../assets/images/event_thumbnail_icon.png';

export interface Deal {
  id: number;
  name: string;
  description: string;
  amount: number;
}

export const CheckoutVoucher = ({ navigation }: any) => {
  const route = useRoute();
  const [voucher] = useState<any>(voucherJson);
  const { eventId } = route.params as { eventId: string };
  const [showMore, setShowMore] = useState<boolean>(false);
  const [selectedVoucher, setSelectedVoucher] = useState<any>(voucher);

  const handleButtonPress = (deal: Deal) => {
    const voucherName = deal.name;
    const voucherAmount = deal.amount;

    navigation.goBack();
    navigation.navigate('checkout', { eventId, voucherName, voucherAmount });
  };

  const handleShowMore = (deal: Deal) => {
    setSelectedVoucher(deal);
    setShowMore(true);
  };

  const renderDealItem = ({ item }: { item: Deal }) => (
    <TouchableOpacity onPress={() => handleShowMore(item)}>
      <View style={styles.dealItem}>
        <View style={{ justifyContent: 'center', flexDirection: 'column' }}>
          <BText style={styles.dealName}>{item.name}</BText>
          <BText style={styles.dealDescription}>{item.description}</BText>
        </View>
        <View style={{ justifyContent: 'center', flexDirection: 'row', alignItems: 'center' }}>
          <FontAwesomeIcon icon={arrowIcon} size="1x" style={{ marginRight: 10 }} />
          <TouchableOpacity onPress={() => handleButtonPress(item)} style={styles.button}>
            <BText style={styles.buttonText}>Apply</BText>
          </TouchableOpacity>
        </View>
      </View>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <FlatList data={voucher} renderItem={renderDealItem} keyExtractor={item => item.id.toString()} />

      <Drawer id="checkout.voucher" visible={showMore} type={'ok'} onClose={() => setShowMore(false)} fullScreen={true}>
        <View style={styles.thumbSMContainer}>
          <Image source={{ uri: voucherThumbnail }} style={styles.thumbImg} />
        </View>
        <BText>{selectedVoucher.description}</BText>
      </Drawer>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: themeConfig.colors.background,
    position: 'relative',
  },
  dealItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5,
    backgroundColor: '#f5f5f5',
    padding: 12,
    borderRadius: 8,
  },
  dealName: {
    fontSize: 15,
    fontWeight: 'bold',
  },
  dealDescription: {
    fontSize: 12,
    color: '#666',
  },
  dealAmount: {
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: 8,
  },
  button: {
    backgroundColor: '#000',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 6,
  },
  buttonText: {
    color: '#fff',
    fontWeight: 'bold',
  },
  thumbSMContainer: {
    width: '100%',
  },
  thumbImg: {
    width: '100%',
    height: undefined,
    aspectRatio: 4 / 3,
  },
});
